/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListProjectSightDrawingsQueryResponse, TrimbleItemsControllerListProjectSightDrawingsQueryParams } from "../../models/trimbleController/TrimbleItemsControllerListProjectSightDrawings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleItemsControllerListProjectSightDrawings } from "../../clients/trimbleService/trimbleItemsControllerListProjectSightDrawings";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleItemsControllerListProjectSightDrawingsQueryKey = (params: TrimbleItemsControllerListProjectSightDrawingsQueryParams) => [{
  url: '/api/v1/trimble/projectsight/drawings'
}, ...(params ? [params] : [])] as const;
export type TrimbleItemsControllerListProjectSightDrawingsQueryKey = ReturnType<typeof trimbleItemsControllerListProjectSightDrawingsQueryKey>;
export function trimbleItemsControllerListProjectSightDrawingsQueryOptions(params: TrimbleItemsControllerListProjectSightDrawingsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleItemsControllerListProjectSightDrawingsQueryKey(params);
  return queryOptions<TrimbleItemsControllerListProjectSightDrawingsQueryResponse, ResponseErrorConfig<Error>, TrimbleItemsControllerListProjectSightDrawingsQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleItemsControllerListProjectSightDrawings(params, config);
    }
  });
}

/**
 * @summary List a ProjectSight project's current drawings, or one drawing set's drawings
 * {@link /api/v1/trimble/projectsight/drawings}
 */
export function useTrimbleItemsControllerListProjectSightDrawings<TData = TrimbleItemsControllerListProjectSightDrawingsQueryResponse, TQueryData = TrimbleItemsControllerListProjectSightDrawingsQueryResponse, TQueryKey extends QueryKey = TrimbleItemsControllerListProjectSightDrawingsQueryKey>(params: TrimbleItemsControllerListProjectSightDrawingsQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleItemsControllerListProjectSightDrawingsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleItemsControllerListProjectSightDrawingsQueryKey(params);
  const query = useQuery({
    ...trimbleItemsControllerListProjectSightDrawingsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}